// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container--2TRmy","logo":"_6eb00b8e53--logo--1Q3E1","description":"_6eb00b8e53--description--K1DFS","promo":"_6eb00b8e53--promo--2ie72"};